export const PluginType = {
  ASSET: 'asset',
};